 /*=========================================================================================
  File Name: mutations.js
  Description: Menus Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Menus State Module
  Author: Tan Tran
==========================================================================================*/
export default {

    SET_MENUS_STATE ( state, payload ) {
        
        state.menus = payload;
    },

    SET_ITEMS_IN_REPOSITORY_STATE ( state, payload ) {
        state.itemsInRepository = payload;
    },

    SET_CURRENT_MENUID_STATE (state, payload) {
        state.currentMenuId = payload;
    },

    ADD_MENU_STATE (state, payload) {
        state.menus.push(payload);
    },

    UPDATE_MENU_STATE (state, payload) {
         let index = state.menus.findIndex(m => m.menuId === payload.menuId);

         if(index > -1) {
            state.menus.splice(index,1);
            state.menus.push(payload);
         }
    }
}